import { render, staticRenderFns } from "./HealthCareInformationDashboardItemSba.vue?vue&type=template&id=60e1c823"
import script from "./HealthCareInformationDashboardItemSba.vue?vue&type=script&lang=js"
export * from "./HealthCareInformationDashboardItemSba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol})
